module.exports = __webpack_public_path__ + "static/media/gptDataCode.22abd80e.mp4";